
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole" [ngClass]="{'general-disabled':project.isMigrationActive}">
  <error [error]="error"></error>
  <div class="row">
    <div class="col">
      <list-controls [search]="dartDeals.searchText" [limit]="dartDeals.pageSize" [page]="dartDeals.currentPage" [numPages]="dartDeals.maxPages" [totalCount]="dartDeals.filteredLength" (onChange)="dartDeals.onListControlsChange($event)">
        <button class="btn btn-primary" importDartDeal [projectId]="workflowTargetInfo.projectId" type="button" (closed)="importDartDealDialogClosed($event)">Import DART Deal</button>
      </list-controls>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="card-item">
        <h5>Devices on this project</h5>
        <div class="container pt-4" style="padding: 0 4.5rem;">
          <div class="row my-3">
            <div class="col-12">
              <property-container>
                <property-item>Total: {{ project?.totalDevices | number:0 }}</property-item>
                <property-item>Available: {{ project?.totalDevices - project?.plannedDevices - project?.totalUsedDevices - project?.totalDisabledDevices | number:0 }}</property-item>
                <property-item>Planned: {{ project?.plannedDevices + project?.totalUsedDevices | number:0  }}</property-item>
                <property-item>Ordered: {{ project?.orderedDevices | number:0  }}</property-item>
                <property-item>Disabled: {{ project?.totalDisabledDevices | number:0  }}</property-item>
                <property-item>Deployed: {{ project?.deployedDevices | number:0  }}</property-item>
              </property-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngFor="let dartDeal of dartDeals.filtered">
    <div class="col">
      <div class="card-item">
        <div class="d-flex justify-content-between mt-3">
          <h4>{{ dartDeal.dealKey }}<span class="badge badge-secondary ml-2" *ngIf="dartDeal.quicksilver">QS</span></h4>
          <div>
            <button class="btn btn-link mr-3" (click)="remove(dartDeal.id)" *ngIf="!dartDeal.asset.planned &amp;&amp; !dartDeal.accessory.planned &amp;&amp; !dartDeal.software.planned">Remove</button>
            <button class="btn btn-outline-primary" (click)="manageDevices(dartDeal)">Manage devices</button>
          </div>
        </div>
        <div class="container" style="padding: 1rem 4.5rem 0;">
          <div class="row">
            <div class="col-12">
              <div class="table table-borderless table-responsive">
                <thead class="text-center">
                  <tr>
                    <th class="border-bottom">&nbsp;</th>
                    <th class="border-bottom">Total</th>
                    <th class="border-bottom">Available</th>
                    <th class="border-bottom">Planned</th>
                    <th class="border-bottom">Ordered</th>
                    <th class="border-bottom">Disabled</th>
                    <th class="border-bottom">Solution Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Devices</td>
                    <td class="text-center">{{ dartDeal.asset.total }}</td>
                    <td class="text-center">{{ dartDeal.asset.available }}</td>
                    <td class="text-center">{{ dartDeal.asset.planned }}</td>
                    <td class="text-center">{{ dartDeal.asset.ordered }}</td>
                    <td class="text-center">{{ dartDeal.asset.disabledCount }}</td>
                    <td class="text-center">{{ dartDeal.asset.solutionCount }}</td>
                  </tr>
                  <tr>
                    <td>Accessories</td>
                    <td class="text-center">{{ dartDeal.accessory.total }}</td>
                    <td class="text-center">{{ dartDeal.accessory.available }}</td>
                    <td class="text-center">{{ dartDeal.accessory.planned }}</td>
                    <td class="text-center">{{ dartDeal.accessory.ordered }}</td>
                    <td class="text-center">{{ dartDeal.accessory.disabledCount }}</td>
                    <td class="text-center">{{ dartDeal.accessory.solutionCount }}</td>
                  </tr>
                  <tr>
                    <td>Software Solutions</td>
                    <td class="text-center">{{ dartDeal.software.total }}</td>
                    <td class="text-center">{{ dartDeal.software.available }}</td>
                    <td class="text-center">{{ dartDeal.software.planned }}</td>
                    <td class="text-center">{{ dartDeal.software.ordered }}</td>
                    <td class="text-center">{{ dartDeal.software.disabledCount }}</td>
                    <td class="text-center">{{ dartDeal.software.solutionCount }}</td>
                  </tr>
                </tbody>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>